import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Invoke}         from "@Common/react/invoke";
import {Load2}          from "@Common/react/load2";
import {AlertModal}    from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";

export const LoadCart = ({cartId, next}) => cs(
    consumeContext("routerHistory"),
    ["cart", (_, next) => cs(
        consumeContext("apis"),
        ({apis}) => Load2({
            _key: cartId,
            fetch: () => apis.next.cart.getCart(cartId),
            captureException: true,
            next,
        }),
    )],
    ({cart, routerHistory}, next) => cart.loading ? (
        "Loading cart data..."
    ) : cart.exception ? (
        ShowCartException({exception: cart.exception, routerHistory})
    ) : cart.value == null ? (
        Invoke({
            action: () => {
                routerHistory.push(`/checkout-success/${cartId}`);
            },
        })
    ) : (
        next()
    ),
    ({cart}) => next(cart),
);

const ShowCartException = ({exception, routerHistory}) => cs(
    ["alertModal", (_, next) => AlertModal({next})],
    ({alertModal}) => Invoke({
        action: async () => {
            await alertModal.show({message: "Failed to load cart data"});
            routerHistory.push(`/`);
        },
    }),
);